import $ from 'jquery'
import {s} from './utils'

export interface Nonfraction {
    name: string
    ctxRef: string
    value: number
    scale: number
}

function getValue(nf: Nonfraction): number {
    return nf.value * nf.scale
}

function getValueOptional(nf: Nonfraction | undefined): number | undefined {
    return nf ? nf.value * nf.scale : undefined
}


function parseNonfraction(name: string, nonfractionElement: HTMLElement): Nonfraction {
    const $x = $(nonfractionElement)
    // console.log(x.tagName)
    const ctxRef = $x.attr('contextref')
    if (!ctxRef) {
        throw "nonfraction element does not contain 'contextref' attribute"
    }
    const scaleStr = $x.attr('scale')
    let scale = 1
    if (scaleStr) {
        scale = Math.pow(10, parseFloat(scaleStr.trim()))
    } else {
        console.debug(`nonfraction[${name}] does not contain 'scale' attribute. using scale 1`)
    }
    // const ctx = ctxMap.get(ctxRef)
    // const parent = $x.parentsUntil(s('ix:nonnumeric')).parent().first().attr('name')

    return {
        name: name,
        ctxRef: ctxRef,
        value: parseFloat($x.text().trim().replace(/,/g, '')),
        scale: scale
    }

}

function find(name: string): Nonfraction[] {
    return $(s(`ix:nonfraction[name=${name}]`))
        .map((_, x) => parseNonfraction(name, x))
        .get()
}

export const nonfraction = {
    find: find,
    parseNonfraction: parseNonfraction,
    getValue: getValue,
    getValueOptional: getValueOptional
}

//todo: refactor this to nonfraction export above
export const findNonnumericParent = function(node: Node) {
    return $(node).parentsUntil(s('ix:nonnumeric')).parent().first().attr('name')
}